import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './tradeDeal.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { DEAL_TYPE } from '~/config/constants';
import { fetchItemApi } from '~/pages/ItemSaga/Item/itemSlice';

TradeDealForm.defaultProps = {
    pictureAttributeNames: null,
};
TradeDealForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function TradeDealForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    const items = useSelector((state) => state.itemSaga.item.rows);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchItemApi(navigate));
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(tradeDealMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values, setFieldValue } = props;
                                useEffect(() => {
                                    if (typeof (values.receive_item_id) == 'string') {
                                        try {
                                            console.log(JSON.parse(values.receive_item_id));
                                            setFieldValue('receive_item_id', JSON.parse(values.receive_item_id));
                                        } catch (e) {
                                        }
                                    }
                                    let data = [];
                                    if (Array.isArray(values.receive_item_quantity))
                                        data = values.receive_item_quantity;
                                    else
                                        data = values.receive_item_quantity.split(',');
                                    if (values.receive_item_id.length != data.length) {
                                        data = JSON.parse(JSON.stringify(data));
                                        for (let i = 0; i < data.length - values.receive_item_id.length; i++) {
                                            data.splice(-1);
                                        }
                                        for (let i = 0; i < values.receive_item_id.length - data.length; i++) {
                                            data.push(1);
                                        }
                                    }
                                    setFieldValue('receive_item_quantity', data);

                                    if (typeof (values.pay_item_id) == 'string') {
                                        try {
                                            console.log(JSON.parse(values.pay_item_id));
                                            setFieldValue('pay_item_id', JSON.parse(values.pay_item_id));
                                        } catch (e) {
                                        }
                                    }
                                    data = [];
                                    if (Array.isArray(values.pay_item_quantity))
                                        data = values.pay_item_quantity;
                                    else
                                        data = values.pay_item_quantity.split(',');
                                    if (values.pay_item_id.length != data.length) {
                                        data = JSON.parse(JSON.stringify(data));
                                        for (let i = 0; i < data.length - values.pay_item_id.length; i++) {
                                            data.splice(-1);
                                        }
                                        for (let i = 0; i < values.pay_item_id.length - data.length; i++) {
                                            data.push(1);
                                        }
                                    }
                                    setFieldValue('pay_item_quantity', data);
                                }, [values]);
                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormSelect
                                                name="deal_type"
                                                options={DEAL_TYPE}
                                                sm={6}
                                                className="d-flex flex-column justify-content-end"
                                                label="Offer type"
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <Selectize
                                                name={'receive_item_id'}
                                                options={items}
                                                label="Receive item id"
                                                sm={6}
                                            />
                                            <FormText
                                                name={'receive_item_quantity'}
                                                label="Receive item quantity"
                                                sm={6}
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <Selectize
                                                name={'pay_item_id'}
                                                options={items}
                                                label="Pay item id"
                                                sm={6}
                                            />
                                            <FormText
                                                name={'pay_item_quantity'}
                                                label="Pay item quantity"
                                                sm={6}
                                            />
                                        </Form.Row>

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default TradeDealForm;
